<template>
  <el-select v-model="valueData" clearable size="mini">
    <el-option
      v-for="(it, idx) in dataSource"
      :key="idx"
      :label="it.text"
      :value="it.value"
      :disabled="it.disabled"
    >
    </el-option>
  </el-select>
</template>
<script>
import { Select, Option } from "element-ui";

export default {
  name: "common-single-selector",
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
  },
  props: {
    value: {
      type: Number,
    },
    dataSource: {
      type: Array,
    },
  },
  model: {
    prop: "value",
    event: "change",
  },
  computed: {
    valueData: {
      get() {
        return this.$props.value;
      },
      set(value) {
        if (value === "") {
          this.$emit("change", null);
        } else {
          this.$emit("change", value);
        }
      },
    },
  },
};
</script>
